import useDebounce from 'Hooks/useDebounce';
import { useCallback, useEffect, useState } from 'react';

const useDropDown = ({ employees = [] }) => {
  const [search, setSearch] = useState('');
  const [terminal, setTerminal] = useState('');
  const [department, setDepartment] = useState('');
  const [status, setStatus] = useState('');

  const [filteredEmployees, setFilteredEmployees] = useState([]);

  const searchDebounced = useDebounce(search, 500);

  /**
   * Devuelve la busqueda por nombre o número de empleado
   * dependiendo del tipo de dato ingresado.
   *
   * #### Nota:
   * ```js
   * employee[0] // Número de empleado
   * employee[1] // Nombre
   * ```
   *
   * @param {string|number} toSearch - Valor a buscar
   * @param {Array} employee - Array de datos del empleado
   * @returns {string|number} Valor a utilizar en la busqueda
   */
  const nameOrEmployeeNumber = useCallback((toSearch, employee) => {
    // Validación sencilla para saber si el valor ingresado es un número o un string
    const isNumber = !Number.isNaN(Number(toSearch));
    switch (isNumber) {
      case true:
        return employee[0].toString().includes(toSearch.toString());
      case false:
        return employee[1]?.toLowerCase().includes(toSearch.toLowerCase());
      default:
        return '';
    }
  }, []);

  useEffect(() => {
    const draft = employees.filter(employee => {
      // Coincidencia de búsqueda por nombre o número de empleado
      const isMatch = nameOrEmployeeNumber(searchDebounced, employee);
      const isTerminal = employee[5] === terminal || terminal === '';
      const isDepartment = employee[2] === department || department === '';
      const isStatus = employee[6] === status || status === '';
      if (isMatch && isTerminal && isDepartment && isStatus) {
        return employee;
      }
    });

    setFilteredEmployees(draft);
  }, [employees, searchDebounced, terminal, department, status]);

  return {
    setSearch,
    setTerminal,
    setDepartment,
    setStatus,
    filteredEmployees,
  };
};

export default useDropDown;
